import Repository from './Repository'

const action = 'user-organizations'

export default {
  getList(settings = {}) {
    let params = `?page=${settings.page || 1}`

    if (settings.status) {
      params += `&master_approve_status=${settings.status}`
    }
    if (settings.org_name) {
      params += `&org_name=${settings.org_name}`
    }

    params += '&only-mine=0&expand=organization,user&sort=-id'

    return Repository.get(action + params)
  },
  postItem(data) {
    return Repository.post(action, data)
  },
  updateItem(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
  getByINN(inn) {
    return Repository.get(
      `${action}?only-mine=0&expand=organization&org_inn=${inn}`,
    )
  },
  get(id) {
    return Repository.get(action + '/' + id + '?expand=organization,user')
  },
}
